import { PLAY } from "@/constants/testIds";
import { AlertTriangle } from "lucide-react";

export default function UnavailableDialog({ open, onClose, title, message }) {
    if (!open) return null;
    return (
        <div
            data-testid={PLAY.lockedDialog}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-md axis-fade-in"
            onClick={onClose}
        >
            <div
                className="axis-glass axis-cut axis-glow max-w-md w-[90%] p-8 border-cyan-400/40"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center gap-3 mb-4">
                    <div className="p-2 border border-amber-400/60 axis-cut-sm">
                        <AlertTriangle size={20} className="text-amber-300" />
                    </div>
                    <div>
                        <div className="axis-mono text-[10px] tracking-[0.4em] text-amber-300/80">
                            ACCESS DENIED
                        </div>
                        <div className="axis-heading text-xl text-white tracking-widest">
                            {title}
                        </div>
                    </div>
                </div>
                <div className="axis-mono text-sm text-white/70 leading-relaxed">
                    {message}
                </div>
                <div className="mt-6 flex justify-end">
                    <button
                        data-testid={PLAY.lockedDialogClose}
                        onClick={onClose}
                        className="axis-btn axis-btn-primary axis-cut-sm px-6 py-2 text-xs"
                    >
                        Acknowledged
                    </button>
                </div>
            </div>
        </div>
    );
}
